import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=3895804f&scoped=true"
import script from "./form2.vue?vue&type=script&lang=js"
export * from "./form2.vue?vue&type=script&lang=js"
import style0 from "./form2.vue?vue&type=style&index=0&id=3895804f&prod&lang=scss&scoped=true"
import style1 from "./form2.vue?vue&type=style&index=1&id=3895804f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895804f",
  null
  
)

export default component.exports